import { http } from '../utils/http'

const searchAction = (page,size) => {
  // const url = `/open/api/v1/index-management/find-all?page=${page-1}&size=${size}`
  const url = `/config/indexManagement/page`
  return http.post(url, {page,size})
};

// 新建保存
const addAction = (params) => {
  // const url = `/open/api/v1/index-management/save`
  const url = '/config/indexManagement/save'
  return http.post(url, params)
};
const editAction = (params) => {
  // const url = `/open/api/v1/index-management/${id}/update`
  const url = '/config/indexManagement/changeStatus'
  return http.post(url, params)
};

// 删除
const deleteAction = (id) => {
  // const url = `/open/api/v1/index-management/${id}/delete`
  const url = `/config/indexManagement/delete/${id}`
  return http.post(url)
};

// 修改
const getAction = (id) => {
  // const url = `/open/api/v1/index-management/${id}/find`
  const url = `/config/indexManagement/get/${id}`
  return http.post(url)
};
const getApiNameAction = (params) => {
  // const url = `/open/api/v1/index-management/find/in-out/info`
  const url = '/config/apiConfigInfo/getListByDirection'
  return http.post(url,params)
};

// 获取新建/编辑 Index Path字段数据
const getSampleDataAction = (id) => {
  // const url = `/open/api/v1/index-management/find/in-out/sample-data`
  const url = `/config/indexManagement/findInOrOutSampleData/${id}`
  return http.post(url)
};

const searchGroupAction = (page,size) => {
  // const url = `/open/api/v1/index-management-group/find-all?page=${page-1}&size=${size}`
  const url = `/config/indexManagementGroup/page`
  return http.post(url, {page,size})
};
const addGroupAction = (params) => {
  // const url = `/open/api/v1/index-management-group/save`
  const url = '/config/indexManagementGroup/save'
  return http.post(url, params)
};
const getGroupAction = (id) => {
  // const url = `/open/api/v1/index-management-group/${id}/find`
  const url = `/config/indexManagementGroup/get/${id}`
  return http.post(url)
};
const editGroupAction = (params,id) => {
  const url = '/config/indexManagementGroup/save'
  // const url = `/open/api/v1/index-management-group/${id}/update`
  return http.post(url, params)
};
const deleteGroupAction = (id) => {
  // const url = `/open/api/v1/index-management-group/${id}/delete`
  const url = `/config/indexManagementGroup/delete/${id}`
  return http.post(url)
};
const getIndexNameAction = () => {
  // const url = `/open/api/v1/index-management-group/find/index-management`
  const url = '/config/indexManagement/list'
  return http.post(url)
};
export default {
  searchAction,
  addAction,
  getAction,
  editAction,
  deleteAction,
  getApiNameAction,
  getSampleDataAction,
  searchGroupAction,
  addGroupAction,
  getGroupAction,
  editGroupAction,
  deleteGroupAction,
  getIndexNameAction
}
